import { Injectable } from '@angular/core';
import { Observable, forkJoin } from 'rxjs';

import { ICreateReportRequest, IReport, IUpdateReportRequest } from './defs';
import { RequestService } from '@app/core/request';

@Injectable({
  providedIn: 'root'
})
export class ReportsService {

  constructor(
    private request: RequestService,
  ) { }

  public getReports(): Observable<IReport[]> {
    return this.request.get<IReport[]>('/api/reports');
  }

  public createReport(request: ICreateReportRequest): Observable<IReport> {
    return this.request.post('/api/reports', request);
  }

  public updateReport(request: IUpdateReportRequest): Observable<IReport> {
    return this.request.put(`/api/reports/${request.id}`, request);
  }

  public deleteReports(ids: number[]): Observable<IReport[]> {
    return forkJoin(ids.map(id => this.request.delete(`/api/reports/${id}`)));
  }
}
